// extracted by css-extract-rspack-plugin
export default {"peopleGrid":"People-module__peopleGrid__rPvM_"};